import React from "react";

import SvgActivity from "@uui/Activity";
import SvgAlertTriangle from "@uui/AlertTriangle";
import SvgAnnouncement03 from "@uui/Announcement03";
import SvgFile07 from "@uui/File07";
import SvgZap from "@uui/Zap";

import { ICON_BY_CATEGORY } from "@app/analytics/components/Icons";

import type { FeedItemType } from "./types";

interface IconConfig {
  Icon: typeof SvgZap;
  color: React.CSSProperties["color"];
  backgroundColor: React.CSSProperties["backgroundColor"];
}

export const ICON_TYPES: {
  [key: string]: IconConfig;
} = {
  action_item: {
    Icon: ICON_BY_CATEGORY.action_items.Icon,
    color: ICON_BY_CATEGORY.action_items.color,
    backgroundColor: "shades.primary.100",
  },
  coaching_recommendation: {
    Icon: SvgAnnouncement03,
    color: "#80B22D",
    backgroundColor: "#E1F2C4",
  },
  report: {
    Icon: SvgFile07,
    color: "#3471CC",
    backgroundColor: "#E1EBFA",
  },
  error: {
    Icon: SvgAlertTriangle,
    color: "avatar.yellow.dark",
    backgroundColor: "avatar.yellow.main",
  },
  question: {
    Icon: ICON_BY_CATEGORY.key_questions.Icon,
    color: ICON_BY_CATEGORY.key_questions.color,
    backgroundColor: ICON_BY_CATEGORY.key_questions.bgcolor,
  },
  for_you: {
    Icon: SvgActivity,
    color: "#CC346B",
    backgroundColor: "#FCDEE9",
  },
  recommendation: {
    Icon: SvgZap,
    color: "#25B3CC",
    backgroundColor: "#DCF7FC",
  },
};

export const TYPE_TO_ICON_CONFIG: {
  [key in FeedItemType]: IconConfig;
} = {
  for_you_topic: ICON_TYPES.for_you,
  for_you_summary: ICON_TYPES.for_you,
  key_question_answer: ICON_TYPES.question,
  key_question: ICON_TYPES.question,
  meeting_report_error: ICON_TYPES.error,
  meeting_report: ICON_TYPES.report,
  action_item: ICON_TYPES.action_item,
  recommendation: ICON_TYPES.recommendation,
};
